



































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import { $t } from "@/lib/i18nHelpers";
import { currencySymbol } from "@/lib/moneyHelpers";
import { NotificationData } from "@/types";
import { ERRORS, EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInput from "@/components/BaseInput";
import PaidActionError from "@/components/PaidActionError";
import { regexInput } from "@/components/TipController/const";

export default defineComponent({
  name: "GoalTipConfirm",
  components: { PaidActionError, BaseInput, BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean },
    user: { type: Object as PropType<UserWithAvatar>, required: true },
    goalId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const showPaidError = ref(false);
    const tipValue = ref("");
    const processing = ref(false);
    const allowSend = computed(() => tipValue.value.length !== 0 && +tipValue.value > 0);

    const tipValueInput = (v: string) => {
      const value = Number(v.replace(currencySymbol, "") ?? 0) || 0;
      if (isNaN(value) || value === 0) {
        tipValue.value = "";
      } else {
        tipValue.value = value.toString();
      }
    };

    const onSuccess = () => {
      emitter.emit<NotificationData>(EVENTS.NOTIFICATION_SHOW, {
        text: $t("Thank you for donation!"),
        image: { user: props.user },
        position: "top",
      });
      emit("close");
    };

    const submit = async () => {
      if (!allowSend.value) return;
      try {
        processing.value = true;
        const tipAmount = tipValue.value;
        providers.FundraisingGoalsProvider.setReceiveErrors(false);
        await providers.FundraisingGoalsProvider.tipCreate({
          data: {
            amount: +tipAmount,
            goalId: props.goalId,
          },
        });
        onSuccess();
        tipValue.value = "";
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
            onSuccessCB: () => (showPaidError.value = true),
          },
        ]);
      } finally {
        processing.value = false;
        tipValue.value = "";
      }
    };

    return {
      processing,
      showPaidError,
      tipValue,
      regexInput,
      currencySymbol,
      submit,
      tipValueInput,
    };
  },
});
